// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"148":"95a15cc5","525":"2e63e3e2","716":"80af9d4b"}[chunkId] + ".js";
};